module.exports = __webpack_public_path__ + "static/media/Scarecrow.1dd905b3.jpg";